
import { Button } from "@/components/ui/button";
import { LogIn, ArrowRight } from "lucide-react";

interface AuthSubmitButtonProps {
  isLoading: boolean;
  isSignUp: boolean;
  loginText: string;
  registerText: string;
  loadingText: string;
}

export const AuthSubmitButton = ({ 
  isLoading, 
  isSignUp,
  loginText,
  registerText,
  loadingText
}: AuthSubmitButtonProps) => {
  return (
    <Button 
      type="submit" 
      className={`w-full mt-6 group shadow-md transition-all duration-300 ${
        isSignUp 
          ? "bg-blue-600 hover:bg-blue-700 text-white" 
          : "bg-primary hover:bg-primary-dark"
      }`}
      disabled={isLoading}
    >
      {isLoading ? (
        loadingText
      ) : isSignUp ? (
        <span className="flex items-center gap-2">
          {registerText}
          <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </span>
      ) : (
        <span className="flex items-center gap-2">
          {loginText}
          <LogIn className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </span>
      )}
    </Button>
  );
};
